export default {
  namespaced: true,
  service_orders: {
    charts: {
      select: "Select a chart",
      bar: "Bars",
      pie: "Doughnut",
      total: "Total orders",
      loading: "Loading available charts…",
      load_error: "Could not load charts.",
      retry: "Retry",
      unavailable: "No service order charts are available for your user.",
      date_hint: "The period uses the attention date and starts with the current month. Use the chart filters to change it.",
    },
    title: "Service orders",
    reference_number: "Reference number",
    company: "Company",
    facility: "Facility",
    attention_date: "Attention date",
    date_filters: "Date filters",
    status: "status",
    status_change_date: "status change date",
    delete_selection: "delete selection",
    required_fields_to_filter_by_date: "Required fields to filter by date",
    pending: "Pending",
    in_review: "In review",
    in_progress: "In progress",
    finished: "Finalized",
    canceled: "Canceled",
    show_maintenance_form: 'Show maintenance form'
  },
};
